<script setup lang="ts">
const currentYear = new Date().getFullYear();
</script>

<template>
    <footer class="app-footer">
        <div class="app-footer__inner">
            <div class="app-footer__trust">
                <svg class="app-footer__trust-icon" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                    <path d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
                </svg>
                <span class="app-footer__trust-text">Your data is encrypted end-to-end</span>
            </div>
            <p class="app-footer__copyright">&copy; {{ currentYear }} CertifID</p>
        </div>
    </footer>
</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;

.app-footer {
    flex-shrink: 0;
    border-top: 1px solid $portal-border;
    background: $portal-surface;
    position: sticky;
    bottom: 0;
    z-index: 10;

    @media (max-width: 767px) {
        position: static;
        background: transparent;
        border-top-color: $portal-border;
        padding-top: 24px;
        margin-top: 16px;
    }

    &__inner {
        max-width: $portal-footer-max-width;
        margin: 0 auto;
        padding: $portal-footer-py 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;

        @media (max-width: 767px) {
            flex-direction: column;
            padding: 0 $portal-section-px 24px;
            gap: 6px;
        }
    }

    &__trust {
        display: flex;
        align-items: center;
        gap: 6px;
        color: $portal-text-mid;
        opacity: 0.6;
    }

    &__trust-icon {
        width: $portal-status-icon;
        height: $portal-status-icon;
        opacity: 0.75;
    }

    &__trust-text {
        font-size: $text-portal-small;
    }

    &__copyright {
        margin: 0;
        font-size: $text-portal-small;
        color: $portal-text-mid;
        opacity: 0.4;
    }
}
</style>
